import { useEffect, useState } from 'react';

/**
 * Hook for automatic slideshow/carousel functionality.
 */
export const useSlideshow = (slideCount: number, interval: number = 3000) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    if (slideCount <= 1) return;

    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slideCount);
    }, interval);

    return () => clearInterval(timer);
  }, [slideCount, interval]);

  return { currentSlide, setCurrentSlide };
};